module.exports = __webpack_public_path__ + "img/product_03.6b1d29c9.png";